import { SemesterService } from 'data/services';
import { SemesterServiceInterface } from 'domain/services';
import { makeGetAllSemestersUser } from 'main/factories/usecases/semesters/remote-get-all-semesters-user-factory';

export const makeSemesterService = (): SemesterServiceInterface => {
  return new SemesterService(makeGetAllSemestersUser());
};
